import { Divider, makeStyles, tokens } from '@fluentui/react-components';
import React, { FC } from 'react';
import MenuBottom from './MenuBottom';

const useStyles = makeStyles({
    container: {
        // Normal flow - let this sit below the scrollable area so scrollbars remain visible
        position: 'relative',
        display: 'grid',
        gridTemplateRows: '1fr',
        placeItems: 'center',
        zIndex: 2000,
        height: '74px', 
        minHeight: '74px', 
        maxHeight: '74px',
        padding: 0,
        marginTop: '-10px',
        // ensure the top edge is flush with the content above
        boxSizing: 'border-box',
    },
    content: {
        display: 'grid',
        gridTemplateRows: 'auto',
        rowGap: 0,
        width: '100%',
        maxWidth: '100%',
        verticalAlign: 'bottom',
        paddingTop: 0,
        paddingLeft: tokens.spacingHorizontalM,
        paddingBottom: tokens.spacingVerticalM,
    },
});

interface MenuBottomZoneProps {
    onCloseMenuRequired?: () => void;
}

const MenuBottomZone: FC<MenuBottomZoneProps> = ({ onCloseMenuRequired }) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <Divider className="menuSmallDivider" style={{ width: '100%', verticalAlign: 'top', marginTop: 0, padding: 0 }} />
            <div className={classes.content}>
                <MenuBottom onCloseMenuRequired={onCloseMenuRequired} />
            </div>
        </div>
    );
};

export default MenuBottomZone;
